class Approver
  constructor: (args = {}) ->
    _.assign @, args
    @birthday ||= ''

module.exports = Approver
